import {errorHandler} from "@/services/errorHandler";

export default {
    name: "external-version",
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        searchExternalVersionUpdates:(context , payload) =>{
            payload = {
                ...context.getters.getGlobalDateRange,
                ...payload
            }
            return axios.get(synergyApi+`external-version-management/searchVersions`,{
                params:payload
            }).then(({data})=>data).catch(err=>errorHandler.tomcatError(err));
        },
        submitExternalDBUpdate:(context , payload) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            payload = {
                user: user.Username,
                ...payload
            }
            let url = synergyApi+"external-version-management/submitVersion"
            return context.dispatch(`sendRequest`,{
                url,
                payload
            })
        },

        validateExternalDB:(context , payload) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            payload = {
                user: user.Username,
                ...payload
            }
            let url = synergyApi+`external-version-management/validateDB?database=${payload.affectedDB}`
            return axios.get(url).then(({data})=>data).catch(err=>errorHandler.tomcatError(err));
        },
        declineExternalUpdateRequest:(context , payload) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            payload = {
                declinedBy: user.Username,
                ...payload
            }
            let url = synergyApi+"external-version-management/declineVersionUpdate"
            return context.dispatch(`sendRequest`,{
                url,
                payload
            })
        },
        approveExternalUpdateRequest:(context , versionNumber) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            let payload = {
                approvedBy: user.Username,
                identifier : versionNumber
            }
            let url = synergyApi+"external-version-management/approveVersionUpdate"
            return context.dispatch(`sendRequest`,{
                url,
                payload
            })
        },

    }
}